/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './checkbox.scss';

class Checkbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkedByProp: false,
            checked: false,
        };

        this.inputId = `checkbox-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
    }

    static getDerivedStateFromProps(props, state) {
        if (props.checked !== state.checkedByProp) {
            return {
                checkedByProp: props.checked,
                checked: props.checked,
            };
        }
        return null;
    }

    handleChangeCheckbox(e) {
        const { checked } = this.state;
        const { onChange } = this.props;
        const checkedNew = !checked;
        this.setState({
            checked: checkedNew,
        });
        onChange(checkedNew);
    }

    render() {
        const { checked } = this.state;
        const { label, hideLabel = false } = this.props;
        const showLabel = label && label.trim().length > 0;

        return (
            <div className={`bt-checkbox`}>
                <input
                    id={this.inputId}
                    type="checkbox"
                    onChange={e => this.handleChangeCheckbox(e)}
                    checked={checked}
                    value="true"
                    aria-label={hideLabel ? label : undefined}
                />
                {showLabel && (
                    <label
                        htmlFor={this.inputId}
                        className={hideLabel ? 'sr-only' : ''}
                    >
                        {label}
                    </label>
                )}
            </div>
        );
    }
}

Checkbox.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
};

Checkbox.defaultProps = {
    label: '',
    checked: false,
    onChange: () => false
};

export default Checkbox;
